import React from 'react';
import { FileTextIcon, LayersIcon, SparklesIcon } from 'lucide-react';
import { collagePrintables } from '../data/content';
type Placement = {
  index: number;
  className: string;
  lead?: boolean;
};

// Indexes refer to collagePrintables. Spans keep every card at its natural proportions.
const layout: Placement[] = [{
  index: 0,
  className: 'col-span-2 lg:col-span-7 z-10',
  lead: true
}, {
  index: 3,
  className: 'col-span-1 lg:col-span-3 lg:-ml-6 lg:rotate-2 z-20'
}, {
  index: 7,
  className: 'col-span-1 lg:col-span-2 lg:-ml-2 lg:-rotate-2 z-10'
}, {
  index: 1,
  className: 'col-span-1 lg:col-span-3 lg:-rotate-1 z-10'
}, {
  index: 2,
  className: 'col-span-2 lg:col-span-6 lg:-mx-4 z-20 order-first lg:order-none',
  lead: true
}, {
  index: 8,
  className: 'col-span-1 lg:col-span-3 lg:rotate-1 z-10'
}, {
  index: 5,
  className: 'col-span-2 lg:col-span-4 lg:rotate-1 z-10'
}, {
  index: 6,
  className: 'col-span-2 lg:col-span-4 lg:-mx-4 lg:-rotate-1 z-20'
}, {
  index: 4,
  className: 'col-span-2 lg:col-span-4 lg:rotate-1 z-10'
}];
const stats = [{
  value: '200+',
  label: 'Versets bibliques',
  Icon: SparklesIcon
}, {
  value: '20+',
  label: 'Modèles à imprimer',
  Icon: LayersIcon
}, {
  value: 'PDF',
  label: 'Prêt à imprimer',
  Icon: FileTextIcon
}];
export function ProductCollage() {
  return <div className="rounded-[32px] bg-white/70 px-5 pb-8 pt-10 shadow-card ring-1 ring-cream-line sm:px-8 lg:px-12 lg:pb-10 lg:pt-12" data-id="element-250" data-mp="3nyrfk2o7q7v0">
      <div className="text-center" data-id="element-251" data-mp="390qqnslr4wad">
        <p className="font-display text-[64px] leading-none text-coral sm:text-[80px]" data-id="element-252" data-mp="3e1dcr5v7phl6">200+</p>
        <p className="mt-2 text-lg font-extrabold uppercase tracking-[0.14em] text-navy sm:text-xl" data-id="element-253" data-mp="301lqkhujkuw3">Versets bibliques prêts à partager</p>
        <p className="mt-1.5 text-sm font-extrabold uppercase tracking-[0.18em] text-gold-deep" data-id="element-254" data-mp="351q8mcb3lxof">20+ modèles imprimables pour partager l’Évangile</p>
      </div>

      <ul className="mt-10 grid grid-cols-2 items-center gap-3 sm:gap-4 lg:grid-cols-12 lg:gap-x-4 lg:gap-y-6" aria-label="Exemples d’imprimables de l’Évangile" data-id="element-255" data-mp="139bt1jw115b6">
        {layout.map(({
        index,
        className,
        lead
      }) => {
        const p = collagePrintables[index];
        return <li key={p.src} className={`relative ${className}`} data-id="element-256" data-mp="wv6ao1qt4k53">
              {lead && <>
                  <span className="absolute inset-0 hidden translate-x-2 translate-y-2 rotate-1 rounded-lg bg-white shadow-card ring-1 ring-navy/5 sm:block" aria-hidden="true" data-id="element-257" data-mp="muvvibl7p2na" />
                  <span className="absolute inset-0 hidden translate-x-4 translate-y-4 rotate-2 rounded-lg bg-cream shadow-card ring-1 ring-navy/5 sm:block" aria-hidden="true" data-id="element-258" data-mp="1kkqt8jj1tfdu" />
                </>}
              <div className="relative rounded-lg bg-white p-2 shadow-sheet ring-1 ring-navy/5" data-id="element-259" data-mp="1aqi2o1dkvwib">
                <img src={p.src} alt={p.alt} loading="lazy" className="h-auto w-full" data-id="element-260" data-mp="15rxdcwzv6x8n" />
              </div>
            </li>;
      })}
      </ul>

      <dl className="mx-auto mt-10 grid max-w-3xl grid-cols-3 divide-x divide-cream-line rounded-2xl bg-cream px-2 py-5 sm:py-6" data-id="element-261" data-mp="1yhe13hcjhpyj">
        {stats.map(({
        value,
        label,
        Icon
      }) => <div key={label} className="flex flex-col items-center px-2 text-center sm:flex-row sm:justify-center sm:gap-3 sm:text-left" data-id="element-262" data-mp="2arva5ewkpvnk">
            <Icon className="mb-2 h-6 w-6 text-coral sm:mb-0" aria-hidden="true" data-id="element-263" data-mp="2fq6n3yi60ma0" />
            <div data-id="element-264" data-mp="2krm6lm4p2kqa">
              <dd className="font-display text-3xl leading-none text-navy sm:text-4xl" data-id="element-265" data-mp="2ks5o51qfn73s">{value}</dd>
              <dt className="mt-1 text-[11px] font-extrabold uppercase tracking-[0.1em] text-ink-soft sm:text-xs" data-id="element-266" data-mp="2os62ynhg1kbd">{label}</dt>
            </div>
          </div>)}
      </dl>
    </div>;
}